import { PLAIN_NUMBER_FORMAT } from '../../../config/metrics';
import type { MetricFormat } from '../../../config/metrics';
import type { KpiOption } from '../config/kpiCatalog';

/**
 * The display format for one report KPI, resolved in three steps:
 *
 * 1. the KPI's own `format` from `promo_metric_grid.requestable_kpis[]` — the
 *    only source for keys that are not in `metrics[]` at all (grid-only inputs
 *    like `rate_per_case`, event/mechanic FYI fields like `offer_type`);
 * 2. the `metrics[]` entry with the same key, via `metricFormatByKey` — this
 *    covers every `plan_metrics` KPI, since that catalog is derived from it;
 * 3. `PLAIN_NUMBER_FORMAT`, so an unknown key still renders as a clean grouped
 *    integer rather than with a spurious decimal or adornment.
 *
 * Resolution is per field, not per object: a KPI that declares only a prefix
 * still inherits its precision from `metrics[]`.
 */
export const resolveKpiFormat = (
    kpiKey: string,
    kpi: KpiOption | undefined,
    metricFormatByKey: Map<string, MetricFormat>,
): MetricFormat => {
    const base = metricFormatByKey.get(kpiKey) ?? PLAIN_NUMBER_FORMAT;
    return {
        allowedDecimals: kpi?.format?.allowedDecimals ?? base.allowedDecimals,
        preUnit: kpi?.format?.preUnit ?? base.preUnit,
        postUnit: kpi?.format?.postUnit ?? base.postUnit,
    };
};
